import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toast__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toast", `toast--${$props.type}`]),
    role: "alert",
    onClick: $setup.dismiss,
    onMouseenter: $setup.pause,
    onMouseleave: $setup.resume
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["toast__icon", `toast__icon--${$props.type}`])
    }, [
      _createVNode(_component_v_icon, {
        size: "12",
        color: "white"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($setup.iconName), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ], 2 /* CLASS */),
    _createElementVNode("span", _hoisted_1, _toDisplayString($props.message), 1 /* TEXT */),
    _createElementVNode("button", {
      type: "button",
      class: "toast__close",
      "aria-label": "Close",
      onClick: _withModifiers($setup.dismiss, ["stop"])
    }, [
      _createVNode(_component_v_icon, { size: "16" }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("mdi-close", -1 /* CACHED */)
        ])),
        _: 1 /* STABLE */,
        __: [0]
      })
    ])
  ], 34 /* CLASS, NEED_HYDRATION */))
}